/**
 * AI assignment algorithm to automatically assign acquisition opportunities to team members
 * @returns {string} Name of the assigned team member
 */
export const aiAssignLead = () => {
  const teamMembers = [
    { name: 'John Smith', role: 'Appraiser', currentLeads: 45, status: 'Available', performanceScore: 0.89 },
    { name: 'Sarah Johnson', role: 'Acquisition Manager', currentLeads: 38, status: 'Available', performanceScore: 0.92 },
    { name: 'Mike Davis', role: 'Appraiser', currentLeads: 52, status: 'Busy', performanceScore: 0.87 },
    { name: 'Lisa Brown', role: 'Acquisition Manager', currentLeads: 41, status: 'Available', performanceScore: 0.91 }
  ];
  
  const available = teamMembers.filter(m => m.status === 'Available');
  
  if (available.length === 0) {
    const leastBusy = teamMembers.reduce((prev, current) => 
      (prev.currentLeads < current.currentLeads) ? prev : current
    );
    return leastBusy.name;
  }
  
  const scored = available.map(member => ({
    ...member,
    score: (member.performanceScore * 0.6) + ((100 - member.currentLeads) / 100 * 0.4)
  }));
  
  scored.sort((a, b) => b.score - a.score);
  return scored[0].name;
};

